import React, { useEffect, useState } from "react";

import ListaCardsPassoAPasso from "../../../../components/ListaCardsPassoAPasso";
import { colorBrandPrimary } from "../../../../global.style";

import { Wrapper, Title, Sorriso } from "./style";

import contentfulClient from "../../../../services/contentful";
import { useSelector, useDispatch } from "react-redux";

const selector = state => ({
	component: state.component
});
export default function ComeceAgora() {
	const { component } = useSelector(selector);
	const dispatch = useDispatch();
	const {
		steps,
		stepsBgColor,
		stepsTitle,
		stepsFirstArrow,
		stepsSecondArrow
	} = component;
	const [stepsData, setStepsData] = useState({
		listaDeCards: [],
		botao: null,
		id: "6PG3Xd982Pq8iLsqSliH3n",
		stackedMobile: false
	});

	const getSteps = async id => await contentfulClient.getEntry(id);

	const getFirstStepData = id => async () => {
		await getSteps(id).then(data => {
			if (data && data !== undefined) {
				const listaFirstStep = stepsData.listaDeCards;
				listaFirstStep.push({
					name: "Card Adquira (passo 1)",
					data: null,
					titulo: data.fields.title,
					corTitulo: data.fields.titleColor || colorBrandPrimary.turquoise,
					templateCard: null,
					descricao: data.fields.description,
					anotacoes: null,
					corTexto: data.fields.textColor || "#ffffff",
					especial: null,
					sizeCardImage: 221,
					alinhamento: "Centro",
					usarBorda: false,
					transparent: true,
					tabCard: null,
					link: null,
					botao: false,
					imagem: {
						title: data.fields.title,
						url: "https://" + data.fields.image.fields.file.url,
						description: null
					}
				});
				setStepsData({ ...stepsData, listaDeCards: listaFirstStep });
			}
		});
	};

	const getSecondStepData = id => async () => {
		await getSteps(id).then(data => {
			if (data && data !== undefined) {
				const listaSecondStep = stepsData.listaDeCards;
				// console.log(listaSecondStep, "step 2");
				listaSecondStep.push({
					name: "Card Ative (passo 2)",
					data: null,
					titulo: data.fields.title,
					corTitulo: data.fields.titleColor || colorBrandPrimary.turquoise,
					templateCard: null,
					descricao: data.fields.description,
					anotacoes: null,
					corTexto: data.fields.textColor || "#ffffff",
					especial: null,
					sizeCardImage: 221,
					alinhamento: "Centro",
					usarBorda: false,
					transparent: true,
					tabCard: null,
					link: null,
					botao: false,
					imagem: {
						title: data.fields.title,
						url: "https://" + data.fields.image.fields.file.url,
						description: null
					}
				});
				setStepsData({ ...stepsData, listaDeCards: listaSecondStep });
			}
		});
	};

	const getThirdStepData = id => async () => {
		await getSteps(id).then(data => {
			if (data && data !== undefined) {
				const listaThirdStep = [...stepsData.listaDeCards];
				listaThirdStep.push({
					name: "Card Como Usar (passo 3)",
					data: null,
					titulo: data.fields.title,
					corTitulo: data.fields.titleColor || colorBrandPrimary.turquoise,
					templateCard: null,
					descricao: data.fields.description,
					anotacoes: null,
					corTexto: data.fields.textColor || "#ffffff",
					especial: null,
					sizeCardImage: 221,
					alinhamento: "Centro",
					usarBorda: false,
					transparent: true,
					tabCard: null,
					link: null,
					botao: false,
					imagem: {
						title: data.fields.title,
						url: "https://" + data.fields.image.fields.file.url,
						description: null
					}
				});
				setStepsData({ ...stepsData, listaDeCards: listaThirdStep });
			}
			//   console.log(stepsData, "teste");
		});
	};

	useEffect(() => {
		(async () => {
			if (steps[0] && steps[0] !== "") {
				await dispatch(getFirstStepData(steps[0]));
			}
			if (steps[1] && steps[1] !== "") {
				await dispatch(getSecondStepData(steps[1]));
			}
			if (steps[2] && steps[2] !== "") {
				await dispatch(getThirdStepData(steps[2]));
			}
		})();
	}, [steps]);

	return (
		<Wrapper style={{ backgroundColor: stepsBgColor }}>
			<Title tamanho="Médio">{stepsTitle}</Title>
			<Sorriso />
			{stepsData.listaDeCards.length > 1 ? (
				<ListaCardsPassoAPasso
					{...stepsData}
					stepsFirstArrow={stepsFirstArrow}
					stepsSecondArrow={stepsSecondArrow}
				/>
			) : (
				""
			)}
		</Wrapper>
	);
}
